import {
  IonButtons,
  IonContent,
  IonHeader,
  IonMenuButton,
  IonPage,
  IonTitle,
  IonToolbar
} from "@ionic/react";
import { EChartOption } from "echarts";
import ReactECharts from "echarts-for-react";
import { useRef } from "react";

let base = +new Date(1988, 9, 3);
let oneDay = 24 * 3600 * 1000;
let data = [[base, Math.random() * 300]];
let marks: any = [];
let level = 0;
for (let i = 1; i < 20000; i++) {
  let now = new Date((base += oneDay));
  let val = Math.round((Math.random() - 0.5) * 20 + data[i - 1][1]);
  data.push([+now, val]);
  if (i % 1000 === 0) {
    marks.push({ coord: [+now, val], value: `Level ${++level}` });
  }
}

const option: EChartOption = {
  xAxis: {
    type: "time"
  },
  yAxis: {
    type: "value",
    splitLine: {
      show: false
    }
  },
  dataZoom: [
    {
      type: "inside",
      start: 0,
      end: 20,
      zoomLock: true
    },
    {
      start: 0,
      end: 20,
      zoomLock: true
    }
  ],
  series: [
    {
      name: "Fake Data",
      type: "line",
      smooth: true,
      symbol: "none",
      areaStyle: {},
      data: data,
      markPoint: {
        data: marks
      }
    }
  ]
};

const SinglePlayer: React.FC = () => {
  const chartRef = useRef<any>(null);
  return (
    <IonPage>
      <IonHeader>
        <IonToolbar>
          <IonTitle>SinglePlayer</IonTitle>
          <IonButtons slot="end">
            <IonMenuButton />
          </IonButtons>
        </IonToolbar>
      </IonHeader>
      <IonContent fullscreen>
        <ReactECharts
          option={option}
          notMerge={true}
          lazyUpdate={true}
          opts={{
            width: 300,
            height: 400
          }}
          ref={chartRef}
          onChartReady={instance => {
            const screenWidth = window.innerWidth;
            const screenHeight = window.innerHeight;
            instance.resize({ width: screenWidth, height: screenHeight * 0.7 });
          }}
        />
      </IonContent>
    </IonPage>
  );
};

export default SinglePlayer;
